export const SERVICE_LIST = "SERVICE_LIST";
export const SERVICE_LIST_ERROR = "SERVICE_LIST_ERROR";
export const SERVICE_LIST_HIDE_ERROR = "SERVICE_LIST_HIDE_ERROR";
export const SERVICE_LIST_START_LOADER = "SERVICE_LIST_START_LOADER";
export const SERVICE_LIST_STOP_LOADER = "SERVICE_LIST_STOP_LOADER";
